
import { defineComponent, reactive, toRefs, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import nineDirections from '@/api/nineDirections'
import router from '@/router/index'
import store from '@/store'

interface ArticleItem {
  newsId: string
  title: string
  showTime: string
  praisesCount: number
}

interface ArticleDetail {
  title: string
  source: string
  showTime: number
  content: string
  hitCount: number
  disclaimers: string
}

interface PageData {
  articleList: ArticleItem[]
  articleDetail: ArticleDetail
  currentNewsId: string
  theme: string
  loading: boolean
  detailLoading: boolean
  pageNo: number
  pageSize: number
  total: number
  courseNo: string
  breadcrumb: Array<{ title: string; routename: string }>
}

export default defineComponent({
  name: 'ArticleDetail',
  setup() {
    const route = useRoute()
    const pageData: PageData = reactive({
      articleList: [],
      articleDetail: {
        title: '',
        source: '',
        showTime: 0,
        content: '',
        hitCount: 0,
        disclaimers: ''
      },
      currentNewsId: '',
      theme: (route.query.theme as string) || 'light',
      loading: false,
      detailLoading: false,
      pageNo: 1,
      pageSize: 20,
      total: 0,
      courseNo: (route.query.courseNo as string) || '',
      breadcrumb: store.state.breadcrumbList || []
    })

    // 获取文章列表
    function fetchArticleList() {
      pageData.loading = true
      nineDirections.schoolCourseArticlePage({
        courseNo: pageData.courseNo,
        pageNo: pageData.pageNo,
        pageSize: pageData.pageSize
      }, {
        username: route.query.userName as string || '',
        token: route.query.token as string || '',
        appcode: 'com.rjhy.uranus',
        clienttype: 'pc'
      }).then((res: any) => {
        pageData.loading = false
        if (res.code === 1 && res.data) {
          pageData.total = res.data.total || 0
          pageData.articleList = res.data.data || []
          // 默认选中第一篇文章
          if (pageData.articleList.length && !pageData.currentNewsId) {
            selectArticle(pageData.articleList[0].newsId)
          }
        }
      }).catch(() => {
        pageData.loading = false
      })
    }

    // 获取文章详情
    function fetchArticleDetail(newsId: string) {
      pageData.detailLoading = true
      nineDirections.newsContent({
        newsId: newsId,
        token: route.query.token as string || '',
        appcode: 'com.rjhy.uranus',
        clienttype: 'pc'
      }, {
       
      }).then((res: any) => {
        pageData.detailLoading = false
        if (res.code === 1 && res.data) {
          pageData.articleDetail = {
            title: res.data.title || '',
            source: res.data.source || '',
            showTime: res.data.showTime || 0,
            content: res.data.content || '',
            hitCount: res.data.hitCount || 0,
            disclaimers: res.data.disclaimers || ''
          }
        }
      }).catch(() => {
        pageData.detailLoading = false
      })
    }

    // 选择文章
    function selectArticle(newsId: string) {
      pageData.currentNewsId = newsId
      fetchArticleDetail(newsId)
    }

    // 举报：打开客户端内举报页
    function gotoReport(e: Event) {
      console.log('pageData.articleDetail',pageData.articleDetail.title)
      e.preventDefault()
      const reportUrl = `https://www.9fzt.com/others/report.html?pushChannel=htz.pc&contentType=article&page=view_the_article&contentId=${pageData.currentNewsId}&content=${encodeURIComponent(pageData.articleDetail.title || '')}`
      console.log('reportUrl',reportUrl)
      window.open(`gw://funccall?funcname=OnOpenBrowser;params=${encodeURIComponent(reportUrl)}`)
    }

    // 格式化时间
    function formatTime(timestamp: number) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    }

    // 滚动加载更多
    function handleScroll(e: Event) {
      const target = e.target as HTMLElement
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 50) {
        if (!pageData.loading && pageData.articleList.length < pageData.total) {
          pageData.pageNo++
          loadMore()
        }
      }
    }

    // 加载更多
    function loadMore() {
      pageData.loading = true
      nineDirections.schoolCourseArticlePage({
        courseNo: pageData.courseNo,
        pageNo: pageData.pageNo,
        pageSize: pageData.pageSize
      }, {
        username: route.query.userName as string || '',
        token: route.query.token as string || '',
        appcode: 'com.rjhy.uranus',
        clienttype: 'pc'
      }).then((res: any) => {
        pageData.loading = false
        if (res.code === 1 && res.data) {
          pageData.articleList = [...pageData.articleList, ...(res.data.data || [])]
        }
      }).catch(() => {
        pageData.loading = false
      })
    }

    onMounted(() => {
      fetchArticleList()
    })

    watch(
      () => route.query.theme,
      (val) => {
        pageData.theme = val as string
      }
    )

    return {
      ...toRefs(pageData),
      selectArticle,
      formatTime,
      handleScroll,
      gotoReport
    }
  }
})
